import classNames from "classnames/bind";
import {ReactComponent as Position} from "assets/image/Layout/Header/ic_position.svg";
import {ReactComponent as Rotation} from "assets/image/Layout/Header/ic_rotation.svg";
import {ReactComponent as Scale} from "assets/image/Layout/Header/ic_scale.svg";
import {ReactComponent as Undo} from "assets/image/Layout/Header/ic_undo.svg";
import {ReactComponent as Redo} from "assets/image/Layout/Header/ic_redo.svg";
import {ReactComponent as Divider} from "assets/image/Layout/Header/ic_divider.svg";
import {TRANSFORM_TYPE} from "utils";
import styles from "./index.module.scss";
import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import {useIntl} from "react-intl";

const cn = classNames.bind(styles);

export default function View({isUndoAble, isRedoAble, currentSelectedTab, onClickSelectTab, onClickUndo, onClickRedo}) {
  const intl = useIntl();

  const TabList = [
    {
      name: TRANSFORM_TYPE.TRANSLATE,
      icon: selected => (
        <CustomTooltip
          description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_POSITION_BTN_DESC"})}
          shortcut={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_POSITION_BTN_SHORTCUT"})}
          placement={"bottom"}
        >
          <Position className={cn("interact", selected && "selected")} />
        </CustomTooltip>
      ),
    },
    {
      name: TRANSFORM_TYPE.ROTATE,
      icon: selected => (
        <CustomTooltip
          description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_ROTATION_BTN_DESC"})}
          shortcut={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_ROTATION_BTN_SHORTCUT"})}
          placement={"bottom"}
        >
          <Rotation className={cn("interact", selected && "selected")} />
        </CustomTooltip>
      ),
    },
    {
      name: TRANSFORM_TYPE.SCALE,
      icon: selected => (
        <CustomTooltip
          description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_SCALE_BTN_DESC"})}
          shortcut={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_SCALE_BTN_SHORTCUT"})}
          placement={"bottom"}
        >
          <Scale className={cn("interact", selected && "selected")} />
        </CustomTooltip>
      ),
    },
  ];

  return (
    <div className={styles.menu}>
      <CustomTooltip
        description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_UNDO_BTN_DESC"})}
        shortcut={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_UNDO_BTN_SHORTCUT"})}
        placement={"bottom"}
      >
        <button type="button" onClick={onClickUndo}>
          <Undo className={`${styles.act} ${isUndoAble ? styles.enabled : styles.disabled}`} />
        </button>
      </CustomTooltip>
      <CustomTooltip
        description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_REDO_BTN_DESC"})}
        shortcut={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_REDO_BTN_SHORTCUT"})}
        placement={"bottom"}
      >
        <button type="button" onClick={onClickRedo}>
          <Redo className={`${styles.act} ${isRedoAble ? "" : styles.disabled}`} />
        </button>
      </CustomTooltip>
      <Divider className={styles.divider} />
      {TabList.map(item => {
        const {icon, name} = item;
        return (
          <button key={name} type="button" onClick={() => onClickSelectTab(name)}>
            {icon(currentSelectedTab === name)}
          </button>
        );
      })}
    </div>
  );
}
